import { IGetFornecedoresAtividadesDropDownUseCase } from "../../../presentation/useCases/read/get_fornecedores_atividades_drop_down_use_case";
import { FornecedorAtividadeDropDown } from "../../models/fornecedor_atividade_dropdown";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedoresAtividadesDropDownUseCase
 */

export class GetFornecedoresAtividadesDropDownUseCase implements IGetFornecedoresAtividadesDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedoresAtividadesDropDown(): Promise<FornecedorAtividadeDropDown[]> {
    return await this.repository.getFornecedoresAtividadesDropDown();
  }
}
